// extracted by css-extract-rspack-plugin
export default {"TagsWrapper":"Tags_TagsWrapper__JA610"};